import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class GlobalMessageHandlerService {
  private errorSubject = new Subject<string>();
  public errorMessages$ = this.errorSubject.asObservable();
  private successSubject = new Subject<string>();
  public successMessages$ = this.successSubject.asObservable();

  emitError(message: string): void {
    this.errorSubject.next(message);
  }

  emitSuccess(message: string): void {
    this.successSubject.next(message);
  }
}
